import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConsolidadoLaboratorioEntity, ServicioLaboratorioService, ConsolidadoLaboratorioBodyEntity } from 'src/app/services/servicio-laboratorio.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-consolidado-laboratorio',
  templateUrl: './reporte-consolidado-laboratorio.component.html',
  styleUrls: ['./reporte-consolidado-laboratorio.component.css']
})
export class ReporteConsolidadoLaboratorioComponent implements OnInit{

  loading: boolean = false;

  logo: string;
  user: string;

  enviados: number;
  atendidos: number;
  pendientes: number;

  fechaImpresion: Date;

  filtrosSelecionados: ConsolidadoLaboratorioEntity;
  detalle: ConsolidadoLaboratorioBodyEntity[] = [];

  public objetoConsolidado: ConsolidadoLaboratorioEntity = {
    codigo : '',
    fechaInicial : 0,
    fechaFinal : 0,
    sede : -1
  };

  constructor(private activatedRoute: ActivatedRoute,
              private servicioImagenes: ImagesService,
              private servicioLaboratorio: ServicioLaboratorioService) { 
    this.activatedRoute.params.subscribe(params => {
        this.objetoConsolidado.codigo = params['codigoBaseDatos'];
        this.objetoConsolidado.fechaInicial = Number(params['fechaInicial']);
        this.objetoConsolidado.fechaFinal = Number(params['fechaFinal']);
        this.objetoConsolidado.sede = params['sede'];
        this.user = params['user'];
    });
  }

  ngOnInit() {

  }

  public async getResponse(){

  }

  public getPrint(){

  }

  public onFiltrosCompletados(obj: ConsolidadoLaboratorioEntity){
    this.loading = true;
    this.filtrosSelecionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo(obj.codigo);
    this.getData();
  }

  async getLogo(codigoBaseDatos: string){
    try{
      this.logo = '';
      let response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if(response != null){
        response.subscribe((data: any) => {
          this.logo = data.source;
        }, (err: HttpErrorResponse) => {
          this.logo = '';
        })
      }
    }catch(e){
      this.logo = '';
    }
  }

  async getData(){
    try{
      this.enviados = 0;
      this.atendidos = 0;
      this.pendientes = 0;
      let response = await this.servicioLaboratorio.getConsolidadoData(this.filtrosSelecionados);
      if(response != null){
        response.subscribe((data: ConsolidadoLaboratorioBodyEntity[]) => {
          this.detalle = data;
          this.loading = false;
          this.detalle.forEach((d: ConsolidadoLaboratorioBodyEntity) => {
            if(d.estadoSolicitud === 1){
              this.pendientes++;
            }else if(d.estadoSolicitud === 2){
              this.atendidos++;
            }
          this.enviados = this.pendientes + this.atendidos;
        });
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    }catch(e){
      console.log(e);
      this.loading = false;
    }
  }

}
